import { Pipe, PipeTransform } from '@angular/core';

import {
  QuoteStatus,
  QUOTE_STATUSES,
  isQuoteStatusAfterOrEqual,
} from '@lockton-apps/shared/interfaces';

import { QuoteStatusMetaPipe } from './quote-status.pipe';

@Pipe({
  name: 'healthEvaluationStatus',
  standalone: true,
})
export class HealthEvaluationStatusPipe
  extends QuoteStatusMetaPipe<{ label: string; icon: string }>
  implements PipeTransform
{
  map = new Map<QuoteStatus, { label: string; icon: string }>([
    [
      QUOTE_STATUSES.FormInitialized,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [
      QUOTE_STATUSES.FormIncomplete,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [QUOTE_STATUSES.FormComplete, { label: $localize`Pending`, icon: 'more' }],
    [QUOTE_STATUSES.OnHold, { label: $localize`Pending`, icon: 'more' }],
    [
      QUOTE_STATUSES.HealthEvaluationRequired,
      { label: $localize`Pending`, icon: 'more' },
    ],
    [
      QUOTE_STATUSES.HealthEvaluationActive,
      {
        label: $localize`Health evaluation required`,
        icon: 'health_evaluation_thin',
      },
    ],
    [
      QUOTE_STATUSES.Quoted,
      {
        label: $localize`Health evaluation accepted`,
        icon: 'health_evaluation_accepted_thin',
      },
    ],
    [
      QUOTE_STATUSES.BrokerApproved,
      {
        label: $localize`Health evaluation accepted`,
        icon: 'health_evaluation_accepted_thin',
      },
    ],
    [
      QUOTE_STATUSES.AwaitingPayment,
      {
        label: $localize`Health evaluation accepted`,
        icon: 'health_evaluation_accepted_thin',
      },
    ],
    [
      QUOTE_STATUSES.Complete,
      {
        label: $localize`Health evaluation accepted`,
        icon: 'health_evaluation_accepted_thin',
      },
    ],
    [QUOTE_STATUSES.QuoteError, { label: 'Error', icon: '' }],
  ]);

  defaultValue = { label: 'Unknown', icon: 'help' };
}
